import { useEffect } from "react";
import { Outlet } from "react-router";
import { setSiteConfig } from "../app/siteSlice";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { useLazyPublicConfigQuery } from "../features/config/configApiSlice";

export default function SiteConfig(props: any) {
	const dispatch = useAppDispatch();
	const config = useAppSelector((state) => state.site.config);
	const [callPublicConfig, result] = useLazyPublicConfigQuery();

	const isExpired = !config?.expirationDate || config.expirationDate < Date.now();

	useEffect(() => {
		if (isExpired && result.isUninitialized) {
			callPublicConfig()
				.unwrap()
				.then((data) => {
					dispatch(setSiteConfig(data));
				})
				.catch((error) => {
					console.log(error);
				});
		}
	}, [isExpired]);

	useEffect(() => {
		if (config) {
			document.documentElement.setAttribute("data-theme", config.site);
		}
	}, [config?.site]);

	return isExpired ? (
		<div className="h-screen flex items-center justify-center">Loading configuration...</div>
	) : (
		<Outlet />
	);
}
